import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert
} from 'reactstrap'
import styled from 'styled-components'
import moment from 'moment'
import { withNamespaces } from 'react-i18next'
import StyledButton from '../../components/Forms/Button'

import { formatHours } from '../../helpers'

import Preloader from '../../components/UI/Preloader'

const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 30px 35px 30px;

  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
  font-size: 13px;
`

const StyledTitle = styled.div`
  margin-bottom: 30px;
  /* margin: 30px auto; */
  font-size: 13px;
  text-align: center;
  color: #19233c;
  text-transform: uppercase;
`

const ModalFooterWrapper = styled(ModalFooter)`
  padding-bottom: 0 !important;
  border: none !important;
`

const StyledContent = styled.div``

const StyledRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 5px;

  div:nth-child(1) {
    flex: 1;
    max-width: 30%;
    text-align: right;
    color: #b0bac9;
    font-weight: 600;
  }
  div:nth-child(2) {
    flex: 1;
    max-width: 70%;
    padding-left: 15px;
    color: #2e384d;
  }
`

class TransactionModal extends Component {
  handleInput = () => {}

  render() {
    const { toggleModal, isOpen, t } = this.props

    const {
      detailLoading,
      detailError,
      currentTransaction
    } = this.props.transactions

    const {
      num,
      insert_time,
      requestor_name,
      subject,
      status,
      accept_time,
      cancel_time,
      hours,
      hour_type,
      work_text,
      planned_date
    } = currentTransaction

    return (
      <Modal
        isOpen={isOpen}
        toggle={toggleModal}
        contentClassName="styled_modal_content"
      >
        <StyledModalContent>
          <StyledTitle>{t('transactionDetail:name')}</StyledTitle>

          <StyledContent>
            {detailLoading && <Preloader />}
            {detailError && (
              <Alert color="danger">{detailError.message}!</Alert>
            )}
            {num && (
              <StyledRow>
                <div>{t('transactionDetail:num')}:</div>
                <div>{num}</div>
              </StyledRow>
            )}
            {insert_time && (
              <StyledRow>
                <div>{t('transactionDetail:insertTime')}:</div>
                <div>{moment(insert_time).format('DD.MM.YY hh:mm')}</div>
              </StyledRow>
            )}
            {requestor_name && (
              <StyledRow>
                <div>{t('transactionDetail:requestorName')}:</div>
                <div>{requestor_name}</div>
              </StyledRow>
            )}
            {subject && (
              <StyledRow>
                <div>{t('transactionDetail:subject')}:</div>
                <div>{subject}</div>
              </StyledRow>
            )}
            {status && (
              <StyledRow>
                <div>{t('transactionDetail:status')}:</div>
                <div>{t(`statuses:${status}`)}</div>
              </StyledRow>
            )}
            {(accept_time || cancel_time) && (
              <StyledRow>
                <div>
                  {accept_time
                    ? t('transactionDetail:acceptTime')
                    : t('transactionDetail:cancelTime')}
                  :
                </div>
                <div>
                  {accept_time
                    ? moment(accept_time).format('DD.MM.YY hh:mm')
                    : moment(cancel_time).format('DD.MM.YY hh:mm')}
                </div>
              </StyledRow>
            )}
            {hours && (
              <StyledRow>
                <div>{t('transactionDetail:hours')}:</div>
                <div>{formatHours(hours)}</div>
              </StyledRow>
            )}
            {hour_type && (
              <StyledRow>
                <div>{t('transactionDetail:hourType')}:</div>
                <div>{t(`hoursTypes:${hour_type}`)}</div>
              </StyledRow>
            )}
            {work_text && (
              <StyledRow>
                <div>{t('transactionDetail:workText')}:</div>
                <div>{work_text}</div>
              </StyledRow>
            )}
            {planned_date && (
              <StyledRow>
                <div>{t('transactionDetail:plannedDate')}:</div>
                <div>{moment(planned_date).format('DD.MM.YY')}</div>
              </StyledRow>
            )}
          </StyledContent>

          <ModalFooterWrapper>
            <StyledButton onClick={toggleModal}>
              {t('common:close')}
            </StyledButton>
          </ModalFooterWrapper>
        </StyledModalContent>
      </Modal>
    )
  }
}

export default compose(
  connect(({ transactions }) => ({ transactions })),
  withNamespaces()
)(TransactionModal)
